import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {  ErrorMessage, useFormik, FormikProvider, } from "formik";
import { Form, FormGroup, FormLabel, Col, Container, Nav, Row, NavDropdown, Button } from "react-bootstrap";

import * as Yup from "yup";
import ShowAlert from "../alert";
import { useNavigate } from "react-router";
import SwaranandhraService from "../../Services/SwaranandhraService"; import KpiService from "../../Services/KpiService"; import Menubar from "../Menubar"; import { FiPower } from "react-icons/fi";

const ChangePassword = () => {
  const navigate = useNavigate();
  const [update,setUpdate]=useState(false)
  const [otpenb,setOtpenb]=useState(true)
  const[maskedNum,setMaskedNum]=useState("")
  const[click,setClick]=useState()
  const password_updated_days =localStorage.getItem("password_updated_days");
  // const Isvaliduser =localStorage.getItem("Isvaliduser");
  const isValidUser = localStorage.getItem("Isvaliduser") === "true";

 const Logout=()=>{
  let params1={
    token:localStorage.getItem("token")
}
  SwaranandhraService.userLogout(params1).then(() => {
    navigate("/SwarnandhraLogin");
    localStorage.removeItem("token");
    localStorage.removeItem("serviceList");
    localStorage.clear();
  })


 }
useEffect(() => {
  const phoneNumber = localStorage.getItem("phone");
  if (phoneNumber && phoneNumber.length > 0) {
    const maskedPhoneNumber = phoneNumber.slice(0, -4).replace(/./g, '*') + phoneNumber.slice(-4);
    setMaskedNum(maskedPhoneNumber);
   
  } else {
    console.error("Invalid phone number.");
  }
  if(phoneNumber===null || phoneNumber ===""){
    ShowAlert("Please Contact Adminstration", "warning");

  }
}, []); 
  const validationSchema = Yup.object().shape({
    oldpassword: Yup.string().required("Required"),
    newPassword: Yup.string().min(10, "Password must be at least 10 characters long").matches(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/, "Password must contain at least one number, one special character, and one uppercase letter.").required("Required*"),
    confirmpassword: Yup.string().oneOf([Yup.ref('newPassword'), null], 'Passwords must match').required('Please confirm your password'),
   
  });
  const formik = useFormik({
    initialValues: {
      userid: "",
      oldpassword: "",
      newPassword: "",
      confirmpassword: "",
      otp:""
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      let params = {
        userid: localStorage.getItem("username"),
        otp:values.otp,
        oldpassword: values.oldpassword,
        newpassword: values.newPassword,
        confirmpassword: values.confirmpassword
      };
      SwaranandhraService.changepassword(params).then((res) => {
        if (res?.data?.SCODE === "01") {
          ShowAlert(res?.data?.SDESC, "success").then(() => {
          Logout()
          })
        } else {
          ShowAlert(res?.data?.SDESC, "warning");

        }

      });
    },
  });

const otpClick=()=>{
  if(!formik.values.oldpassword){
    ShowAlert("Old password required","error");return;
  }
  setClick(true)
  let params = {
    userId: localStorage.getItem("username"),
  };
  KpiService.sendOtp(params).then((res) => {
    if(res.data.SCODE==="01"){
      ShowAlert(res.data.SDESC,"success").then(()=>{ setUpdate(true) ;setOtpenb(false) })

    }  
    else { ShowAlert(`${res?.data?.SDESC}. Please Contact Administration.`, "warning").then(()=>{ Logout() })

      setOtpenb(true)

    }
  }).catch((error) => { console.error("Error saving data:", error); ShowAlert("Failed to save data.", "warning"); });
  
}



  

  return (
    <>
     
     {(password_updated_days < 180 && isValidUser ) ? <Menubar />

     :


    <section id="">
            <Container fluid>
              <Row className=" ">
                <div className="d-block d-sm-flex justify-content-between logo-all px-3">
                  <div className="d-flex">
                    <div>
                      <img src="../images/aplogo.webp" width="70px" alt="APlogo" className="img-fluid" />
                    </div>
                    <div className="header-logo">
                      <h1>
                        SWARNA <span>ANDHRA @2047</span>
                      </h1>
                      <h5>A.P. PLANNING DEPARTMENT</h5>
                    </div>
                  </div>
                  <div className="log-details">
                    <Nav>
                      <div className="d-flex align-items-center gap-2">
                        <div className="header-dropdown-setting d-flex align-items-center">
                          <b className="me-1">WELCOME:</b>
                          <span>
                            {localStorage.getItem("dispName")},&nbsp;&nbsp;{localStorage.getItem("username")}&nbsp;&nbsp;
                          
                          </span>
                        </div>
                     
                        <NavDropdown style={{ fontFamily: "sans-serif" }} title={<img src="../images/welcome-user.webp" style={{ cursor: "pointer", width: "40px", height: "40px", borderRadius: "50%" }} alt="User" />} id="basic-nav-dropdown" className="custom-dropdown">
                        
                          <NavDropdown.Item className="dropdown-item text-danger d-flex align-items-center gap-2" onClick={Logout}>
                            <FiPower size={20} /> <span className="fw-bold">Logout</span>
                          </NavDropdown.Item>
                        </NavDropdown>
                      </div>
                    </Nav>
                  </div>
                </div>
              </Row>
            </Container>
          </section>
     }
 

      <FormikProvider value={formik}>
        <Form onSubmit={formik.handleSubmit}>

          <Container  className='map-header4'>
            <div className='sa-title'>
              <h2>Change <span>Password</span></h2>
            </div>
          </Container>


          <Container className="outer-page-content-container1 mainpage-container "  style={{ width: "50%" }} >
            <Container className="change-container">
            <div className="justify-content-center" >
              {otpenb&&<>
              <Row className="p-3 justify-content-center old-pass" >
                <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                  <FormGroup as={Col}>
                    <FormLabel> <h6 style={{ color: "var(--dark-gray)", fontWeight: "Bold", }} > Old Password </h6> </FormLabel>
                    <span className="mandatory" style={{ color: "red" }}> * </span>
                    <div className="input-group flex-nowrap">
                    <input autoComplete="new-password" type="password" name="oldpassword" maxLength={20} placeholder="Old password" onChange={(e)=>{formik.setFieldValue('oldpassword',e.target.value)}} className={formik.touched.oldpassword && formik.errors.oldpassword ? "form-control is-invalid" : "form-control"} />
                    
                    </div>
                    {formik.touched.oldpassword && formik.errors.oldpassword && (<div className="invalid-feedback"> <span style={{ color: 'red' }}>required</span> </div>)}

                  </FormGroup>
                </Col>
              </Row>
              <Row className="p-3 justify-content-center">
                <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                  <FormGroup as={Col}>
                    <FormLabel> <h6 style={{ color: "var(--dark-gray)", fontWeight: "Bold", }} >Mobile Number</h6> </FormLabel>
                    <span className="mandatory" style={{ color: "red" }}> * </span>
                    <input type="text" name="mobile_number"  value={maskedNum} disabled={true}className="form-control sample" />


                    <ErrorMessage name="mobile_number" className="text-error" component="div" />

                  </FormGroup>
                </Col>
              </Row>
              <Row className="p-3 justify-content-center">
  <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="d-flex justify-content-center">
    <div className="d-grid">
      <button type="button" className="btn btn-primary btn-sm" disabled={click} onClick={()=>{otpClick()}}>Get Otp</button>
    </div>
  </Col>
</Row></>}

{update&& <>
<Row className="mb-3"> <Col xs="12" className="text-end"> <Button onClick={() => { setUpdate(false); setOtpenb(true);setClick(false); }} className="mt-4 btn-dark btn-sm" > Back</Button> </Col> </Row>

  <Row className="p-3 justify-content-center" >
                <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                  <FormGroup as={Col}>
                    <FormLabel> <h6 style={{ color: "var(--dark-gray)", fontWeight: "Bold", }} > Enter Otp </h6> </FormLabel>
                    <span className="mandatory" style={{ color: "red" }}> * </span>
                    <input  type="text" name="otp"  placeholder="Otp" maxLength={6} onChange={(e)=>{formik.setFieldValue('otp',e.target.value)}} className="form-control sample"  />
                    <ErrorMessage name="otp" className="text-error" component="div" />

                  </FormGroup>
                </Col>
              </Row>
         <Row className="p-3 justify-content-center" >
                <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                  <FormGroup as={Col}>
                    <FormLabel> <h6 style={{ color: "var(--dark-gray)", fontWeight: "Bold", }} > New Password </h6> </FormLabel>
                    <span className="mandatory" style={{ color: "red" }}> * </span>
                    <input type="password" name="newPassword" maxLength={20} placeholder="New password" className="form-control sample" onChange={(e)=>{formik.setFieldValue('newPassword',e.target.value)}} />
                    <ErrorMessage name="newPassword" className="text-error" component="div" />


                  </FormGroup>
                </Col>
              </Row>
              <Row className="p-3 justify-content-center" >
              <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                  <FormGroup as={Col}>
                    <FormLabel> <h6 style={{ color: "var(--dark-gray)", fontWeight: "Bold", }} > Confirm Password </h6> </FormLabel>
                    <span className="mandatory" style={{ color: "red" }}> * </span>
                    <input type="password" name="confirmpassword" maxLength={20} placeholder="confirm password" className="form-control sample" onChange={(e)=>{formik.setFieldValue('confirmpassword',e.target.value)}}/>


                    <ErrorMessage name="confirmpassword" className="text-error" component="div" />

                  </FormGroup>
                </Col>
                </Row>
             
              <Row className="p-3 justify-content-center">
                <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="d-flex justify-content-end" >
                  <div class="d-grid  mt-9  "> <button type="submit" className="btn btn-success btn-sm" > Update </button> </div>
                </Col>
              </Row></>}
            </div>
            </Container>
           
          </Container>
        </Form>
      </FormikProvider>
    </>
  );
};
export default ChangePassword;
